import React from 'react';
import ShowMore from 'react-show-more';
import molecules from 'ctsutheme/components/molecules';

const { ListItem, ListItemText } = molecules;

const FormViewContent = ({
  name, primaryText, secondaryClassName, secondaryText, children, className, more
}) => (
  <ListItem
    className={className}
  >
    <ListItemText
      data-testid={`test_${primaryText?.toLowerCase?.()?.split?.(' ')?.join('_')}`}
      flex
      primary={primaryText}
      data-id={name}
      className={secondaryClassName}
      secondaryTypographyProps={{
        component: 'div'
      }}
      secondary={
            more ? (
              <ShowMore
                lines={3}
                more="Show more"
                less="Show less"
              >
                {secondaryText}
              </ShowMore>
            ) : (
              <div className="col-12">{secondaryText}</div>
            )
          }
    />
    {children}
  </ListItem>
);

const FormSubtitle = ({children, paddingClass}) => {
  return <div className={`form-layout-title font-btn color-dark-blue font-bold d-flex ${paddingClass || 'p-2'}`}>{children}</div>
}

export { FormViewContent, FormSubtitle };
